import type { Guide, GuideRecordHint } from '../types';

/**
 * S-21.10-11 — eksport do TMS jedną akcją, stany „wysłane do TMS” i „zapisane w TMS” (scenariusz e2e 20,
 * krok 20.1; ścieżki ADM-01, ADM-02, ADM-03, MIX-05). Rekordy: zlecenie bezpośrednie Administracji C2
 * z kompletem danych dla importera, zaakceptowane — koperta zapisu w szkicu — i C3 po eksporcie („wysłane do
 * TMS”, dane pod slajdy z 22.10.2026; oba z `scenario-state.mjs`).
 */
const CONTROL: GuideRecordHint = {
  description: 'prezlecenie u Administracji, zaakceptowane, przed plikiem — z kolejki „Do kontroli”',
  listPath: '/pre-orders',
  listFilter: { intakeQueue: 'adm_control' },
};

const SENT: GuideRecordHint = {
  description: 'prezlecenie po eksporcie, przed importem z TMS — z kolejki „Plik wytworzony, czeka na TMS”',
  listPath: '/pre-orders',
  listFilter: { intakeQueue: 'adm_waiting_tms' },
};

export const guide: Guide = {
  flagKey: 'tmsExportOneStep',
  title: 'Eksport do TMS jedną akcją; „wysłane do TMS” i „zapisane w TMS”',
  whatItDoes:
    'Zapis zlecenia do VIA to jedna akcja: „Eksportuj do TMS” otwiera podgląd pliku (przy zleceniu z wózkiem — obu plików) z brakami, podobnymi zleceniami i miejscem dostarczenia, a „Potwierdź zapis” zatwierdza i wytwarza pliki jedną decyzją — dotąd były to osobne „Sprawdź plik”, „Zatwierdź” i „Wytwórz plik”. Zapisuje się tylko to, co było w podglądzie: gdy dane zmienią się w międzyczasie, zapis odmawia i podgląd trzeba otworzyć jeszcze raz. Stany nazywają się teraz „wysłane do TMS” (plik wyszedł, czeka na import) i „zapisane w TMS” (dotąd „Jest w TMS”).',
  audience: ['Administracja'],
  presentationItems: ['S-21.10-11'],
  steps: [
    {
      route: '/pre-orders/:preOrderId/control',
      record: CONTROL,
      target: 'adm-zlecenie-eksportuj-tms',
      mockupTestId: 'adm-zlecenie-eksportuj-tms',
      title: 'Przycisk „Eksportuj do TMS”',
      description:
        'Panel „Zapis do VIA” w oknie kontroli (i na karcie zlecenia) ma jeden przycisk zamiast trzech. Samo otwarcie podglądu niczego nie zapisuje.',
      action: 'W oknie kontroli prezlecenia kliknij „Eksportuj do TMS”.',
      recorder: { account: 'adm', demo: { kind: 'scenario', key: 'c2PreOrderId' } },
    },
    {
      route: '/pre-orders/:preOrderId/control',
      record: CONTROL,
      target: 'tms-export-file-MAIN',
      mockupTestId: 'adm-eksport-potwierdz-zapis',
      title: 'Podgląd pliku i „Potwierdź zapis”',
      description:
        'Okno pokazuje treść pliku, który pójdzie do VIA, i czy ma komplet pól wymaganych przez importer. „Potwierdź zapis” zatwierdza tę treść i od razu wytwarza plik; kto i kiedy zatwierdził, zapisuje się samo.',
      action: 'Sprawdź podgląd i kliknij „Potwierdź zapis” — albo „Anuluj”, jeśli coś trzeba poprawić.',
      recorder: {
        account: 'adm',
        demo: { kind: 'scenario', key: 'c2PreOrderId' },
        actions: [{ kind: 'click', target: 'adm-zlecenie-eksportuj-tms' }],
      },
    },
    {
      route: '/pre-orders/:preOrderId/control',
      record: SENT,
      target: 'control-state',
      title: 'Stan „wysłane do TMS” po eksporcie',
      description:
        'Po potwierdzeniu zlecenie jest „wysłane do TMS” — plik wyszedł i czeka na import, a sekcja mówi, kiedy i kto zatwierdził. Gdy import z TMS pokaże zlecenie, stan zmienia się na „zapisane w TMS” z numerem TMS. Te same nazwy są na liście zleceń VIA i w etapie prezlecenia w banku.',
      action: 'Otwórz prezlecenie po eksporcie i sprawdź sekcję „Stan zapisu do VIA”; zmiana danych po zapisie nadal cofa zatwierdzenie.',
      recorder: { account: 'adm', demo: { kind: 'scenario', key: 'c3PreOrderId' } },
    },
  ],
};
